import {
  type CoreSkillLevel,
  DigitalSkillLevel,
} from "#constants/skillLevelConstants"
import {
  type CurriculumConstructor,
  type CurriculumForTable,
} from "#customTypes/composedTypes/curriculumTypes"
import { type Uuid } from "#customTypes/globalTypes"
import { semesterLookup } from "#forms/SemesterDropdown"
import { camelToWords } from "#utils/textFormatters"

export class Curriculum {
  id: Uuid
  name: string
  semester: string
  numberOfSessions: number
  group: string
  cycle: string
  skillLevels: CoreSkillLevel[] | DigitalSkillLevel[]
  notes: string
  projectIds: Uuid[]

  constructor(props: CurriculumConstructor) {
    this.id = props.id
    this.name = props.name
    this.semester = props.semester
    this.numberOfSessions = props.numberOfSessions ?? 0
    this.group = props.group
    this.cycle = props.cycle
    this.skillLevels = props.skillLevels ?? []
    this.notes = props.notes
    this.projectIds = props.projectIds ?? []
  }

  hasNoProjects = (): boolean => {
    return this.projectIds.length === 0
  }

  getDisplayName = (): string => {
    if (this.hasNoProjects()) return `⚠ ${this.name} (no projects)`

    return this.name
  }

  getCurriculumForTable = (): CurriculumForTable => {
    return {
      id: this.id,
      name: this.getDisplayName(),
      semester: semesterLookup(this.semester),
      numberOfSessions: this.numberOfSessions.toString(),
      group: camelToWords(this.group),
      cycle: this.cycle,
      skillLevels: this.skillLevels.join(", "),
      notes: this.notes,
    }
  }
}
